import { combineReducers } from "redux";
import { API } from "../../const";
import { Service } from "../service/service"
import { unAuthorized } from '../auth/Auth.ducks'
import kids, { FETCH_KIDS_FULFILLED, FILTER_KIDS_FULFILLED } from "./kids-list/Kids-list.ducks";
import addKid, { ADD_KID_FULFILLED } from "./add-kid/Add-kid.ducks";
import _ from "lodash";


export const FETCH_ONE_KID_PENDING = "FETCH_ONE_KID_PENDING";
export const FETCH_ONE_KID_REJECTED = "FETCH_ONE_KID_REJECTED";
export const FETCH_ONE_KID_FULFILLED = "FETCH_ONE_KID_FULFILLED";

export const FETCH_ARCHIVE_KID_PENDING = "FETCH_ARCHIVE_KID_PENDING";
export const FETCH_ARCHIVE_KID_REJECTED = "FETCH_ARCHIVE_KID_REJECTED";
export const FETCH_ARCHIVE_KID_FULFILLED = "FETCH_ARCHIVE_KID_FULFILLED";

export const fetchOneKid = (tok, id) => {
  return (dispatch) => {
    dispatch({ type: FETCH_ONE_KID_PENDING })
    const response = Service.get(`${API}api/enfant/creche/enfants/${id}`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: FETCH_ONE_KID_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: FETCH_ONE_KID_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
};

export const fetchArchiveKid = (tok, id) => {
  return (dispatch) => {
    dispatch({ type: FETCH_ARCHIVE_KID_PENDING })
    const response = Service.get(`${API}api/enfant/creche/enfants/archives/${id}`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: FETCH_ARCHIVE_KID_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: FETCH_ARCHIVE_KID_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
};

// Reducers

const ids = (state = [], { type, payload, filter }) => {
  switch (type) {
    case FETCH_KIDS_FULFILLED:
      {
        return _.isEmpty(payload.data.enfants) ? null : [...new Set(state.concat(payload.data.enfants.map(kid => kid.id)))];
      }
    case FILTER_KIDS_FULFILLED:
      {
        return filter === "TOUS" ? [...new Set(state.concat(payload.map(kid => kid.id)))]
          : payload.map(kid => { if (kid.agenda.statutDetails.statut === filter) { return kid.id } else { return null } }).filter(kid => kid);
      }
    case ADD_KID_FULFILLED:
      return [payload.data._id, ...state];
    default:
      return state;
  }
};

const byId = (state = {}, { type, payload }) => {
  switch (type) {
    case FETCH_KIDS_FULFILLED:
      {
        return _.isEmpty(payload.data.enfants) ? null : payload.data.enfants.reduce(
          (res, kid) => Object.assign({}, res, { [kid.id]: kid }),
          state
        );
      }
    case FETCH_ONE_KID_FULFILLED:
      {
        return _.isEmpty(payload.data) ? null : Object.assign({}, state, { [payload.data.id]: payload.data });
      }

    case ADD_KID_FULFILLED: {
      return Object.assign({}, state, { [payload.data._id]: payload.data });
    }

    default:
      return state;
  }
};
const byIdArchive = (state = {}, { type, payload }) => {
  switch (type) {
    case FETCH_ARCHIVE_KID_FULFILLED:
      {
        return _.isEmpty(payload.data) ? null : Object.assign({}, state, { [payload.data.enfant.id]: payload.data });
      }
    default:
      return state;
  }
};
const errorByID = (state = false, { type, payload }) => {
  switch (type) {
    case FETCH_ONE_KID_REJECTED:
    case FETCH_ARCHIVE_KID_REJECTED:
      return true
    case FETCH_KIDS_FULFILLED:
    case FETCH_ONE_KID_FULFILLED:
    case FETCH_ARCHIVE_KID_FULFILLED:
      return false
    default:
      return state;
  }
};

export default combineReducers({
  ids,
  byId,
  byIdArchive,
  errorByID,
  list: kids,
  add: addKid
});
